export default __webpack_public_path__ + "static/media/image-15.f405e286.webp";